var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35657 2.0095L7.35644 2.00957L7.36331 2.02141C7.45133 2.17297 7.59733 2.40941 7.88784 2.53375C8.10444 2.62646 8.3502 2.62561 8.50607 2.62508C8.51735 2.62504 8.52817 2.625 8.53846 2.625H14.0067C14.7589 2.625 15.375 3.24503 15.375 3.9954V12.0046C15.375 12.7599 14.7588 13.375 13.9932 13.375H2.00685C1.24516 13.375 0.625 12.7528 0.625 11.9975V2.00247C0.625 1.23867 1.235 0.625 2.00516 0.625H5.30769C5.89521 0.625 6.24817 0.731851 6.50305 0.896893C6.76428 1.06605 6.99509 1.34277 7.25325 1.82221L7.25322 1.82223L7.25634 1.82788L7.35657 2.0095Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68457 8.00006H11.3146",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.315V4.685",
    stroke: "currentColor",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFolderIcon);
export default __webpack_public_path__ + "static/media/new-folder-icon.c6d7d65218c4e901807f643b04e1bb9b.svg";
export { ForwardRef as ReactComponent };